import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Actions as MYACTIONS } from "../../store/actions/myActions";
import { Actions as ACTIONS } from "../../store/actions/timesheetActions";
import { Actions as WORKLOCATIONACTIONS } from "../../store/actions/workLocationActions";
// import axios from 'axios';
import { LinkIcon, MinusCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import {
	differenceInDays,
	format,
	isAfter,
	set,
	setHours,
	setMilliseconds,
	setMinutes,
	setSeconds,
	subYears,
} from "date-fns";
import DatePicker from "react-datepicker";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import * as yup from "yup";
import { DateInputFormat, TimeInputFormat } from "../common/DateComponents";

let numSchema = yup.object().shape({
	hours: yup.number().min(0).max(24).nullable(true),
	minutes: yup.number().min(0).max(1440).nullable(true),
});

const timeToHours = (time) => {
	const parts = time.split(":");

	const hours = parseInt(parts[0]) + parseInt(parts[1]) / 60;

	return hours;
};

const isNumber = (a) => !isNaN(a);

const TimesheetModal = ({
	employeeList,
	employeeListWithSalary,
	timesheetStatusOptions,
	modalState,
	modalSaving,
	modalTimesheet,
	timesheetSetOpenModal,
	getWorkLocationSettings,
	workLocationOptions,
	timesheetSave,
	myAgreements,
	mySaveTimesheet,
	employeeDetails,
	location,
}) => {
	// const employeeListWithSalary

	// console.log('modalState', modalState, modalSaving)

	// console.log('employeeList', employeeList)
	// console.log('AgreementOptions', myAgreements)

	const today = new Date();
	const [canEditHours, setCanEditHours] = useState(false);
	const [employee, setEmployee] = useState();

	const [status, setStatus] = useState(timesheetStatusOptions[0]);
	const [hours, setHoursWorked] = useState(8);
	const [date, setDate] = useState(today);
	// const [timeIn, setTimeIn] = useState(new Date(`${today.toISOString().substring(0,10)} 9:00`));
	// const [timeOut, setTimeOut] = useState(new Date(`${today.toISOString().substring(0,10)} 17:00`));
	const [timeIn, setTimeIn] = useState(setHours(setMinutes(setSeconds(setMilliseconds(today, 0), 0), 0), 9));
	const [timeOut, setTimeOut] = useState(setHours(setMinutes(setSeconds(setMilliseconds(today, 0), 0), 0), 17));
	const [breakDuration, setBreakDuration] = useState(0);
	const [notes, setNotes] = useState([]);
	const [workLocation, setWorkLocation] = useState();
	const [comment, setComment] = useState();

	const [errorText, setErrorText] = useState("");

	// const employeeOptions = (employeeList)
	//   ?.map(employee => {
	//     if (!employee?.terminationDate || (isAfter(new Date(employee?.terminationDate), today)) || (differenceInDays(today, employee?.terminationDate) <= 31)) {
	//       return {
	//         value: employee.id,
	//         employeeId: employee.employee,
	//         label: `${employee?.employeeDetails?.givenName} ${employee?.employeeDetails?.familyName}`,
	//         terminationDate: employee.endDate
	//       }
	//     }
	//   })
	//   ?.filter(employee => {
	//     return employee !== undefined;
	//   })

	const employeeOptions = employeeListWithSalary
		?.map((employee) => {
			if (
				!employee?.terminationDate ||
				isAfter(new Date(employee?.terminationDate), today) ||
				differenceInDays(today, new Date(employee?.terminationDate)) <= 61
			) {
				return {
					value: employee.id,
					employeeId: employee.employee,
					label: `${employee?.employeeName} ${employee?.employeeSurname}`,
					terminationDate: employee.terminationDate,
				};
			}
		})
		?.filter((employee) => {
			return employee !== undefined;
		});

	// const unfilteredEmployeeOptions = employeeList?.map(employee => ({

	//   value: employee.id,
	//   employeeId: employee.employee,
	//   label: `${employee?.employeeDetails?.givenName} ${employee?.employeeDetails?.familyName}`,
	//   terminationDate: employee.endDate
	// }))

	const unfilteredEmployeeOptions = employeeListWithSalary?.map((employee) => ({
		value: employee.id,
		employeeId: employee.employee,
		label: `${employee?.employeeName} ${employee?.employeeSurname}`,
		terminationDate: employee.terminationDate,
	}));

	const agreementOptions =
		myAgreements &&
		myAgreements.map((agreement) => ({
			value: agreement.id,
			label: `${agreement.companyName}`,
		}));

	const hasRequired = employee && hours && date && timeIn && timeOut;
	const isValid = hours > 0 && hours <= 24 && hours && breakDuration >= 0;

	useEffect(() => {
		getWorkLocationSettings();
	}, []);

	useEffect(() => {
		if (!modalTimesheet && employee?.terminationDate && employee?.terminationDate < format(date, "yyyy-MM-dd")) {
			setDate(employee && employee.terminationDate && new Date(employee.terminationDate));
		}
	}, [employee]);

	useEffect(() => {
		if (!employee && employeeOptions && employeeOptions.length > 0 && location) {
			if (location != "timesheetPage") return setEmployee(employeeDetails);
			setEmployee(employeeOptions[0]);
		}
	}, [employeeOptions && employeeOptions.length, location]);

	useEffect(() => {
		if (modalTimesheet) {
			const selectedEmployee = unfilteredEmployeeOptions?.find((item) => item.value == modalTimesheet.agreement);

			if (modalTimesheet.status == "deleted")
				setStatus(timesheetStatusOptions?.find((item) => item.value == modalTimesheet.status));
			setEmployee(selectedEmployee);
			setDate(new Date(modalTimesheet.date));
			setHoursWorked(parseFloat(modalTimesheet.hours) || 0);
			console.log("datetimein", `${modalTimesheet.date} ${modalTimesheet["time-in"]}`);
			const timeInSplit = modalTimesheet["time-in"].split(":");
			const timeOutSplit = modalTimesheet["time-out"].split(":");
			const newTimeIn = setHours(
				setMinutes(
					setSeconds(setMilliseconds((modalTimesheet && new Date(modalTimesheet.date)) || today, 0), 0),
					parseInt(timeInSplit[1]),
				),
				parseInt(timeInSplit[0]),
			);
			const newTimeOut = setHours(
				setMinutes(
					setSeconds(setMilliseconds((modalTimesheet && new Date(modalTimesheet.date)) || today, 0), 0),
					parseInt(timeOutSplit[1]),
				),
				parseInt(timeOutSplit[0]),
			);
			console.log("newTimeIn", newTimeIn, timeIn);
			setTimeIn(newTimeIn);
			setTimeOut(newTimeOut);
			setBreakDuration(modalTimesheet.break || modalTimesheet.breakDuration || 0);
			setComment(modalTimesheet.note || "");
			setWorkLocation(
				workLocationOptions.find((w) => String(w.value) === String(modalTimesheet.workLocation)) || null,
			);
			setStatus(
				timesheetStatusOptions.find(
					({ value: s }) => String(s).toLowerCase() === String(modalTimesheet.status).toLowerCase(),
				),
			);
		} else {
			setDate(today);
			setTimeIn(setHours(setMinutes(setSeconds(setMilliseconds(today, 0), 0), 0), 9));
			setTimeOut(setHours(setMinutes(setSeconds(setMilliseconds(today, 0), 0), 0), 17));
			setComment("");
			setBreakDuration(0);
			setHoursWorked(8);
			setStatus(timesheetStatusOptions[0]);
			setWorkLocation(null);

			// setNotes([])
		}
	}, [modalState]);

	console.log("modalState", modalState);
	console.log("employeeOptions", employeeOptions);
	console.log("agreementOptions", agreementOptions);
	// || (!employeeOptions && !agreementOptions)
	if (!modalState) {
		return null;
	}

	const saveTimesheetData = () => {
		const timesheetData = {
			...modalTimesheet,
			"agreement": employee.value,
			"employee": employee?.employeeId,
			"time-in": format(timeIn, "HH:mm"),
			"time-out": format(timeOut, "HH:mm"),
			"date": date.toISOString(),
			"break": parseFloat(breakDuration),
			"hours": parseFloat(hours),
			"workLocation": workLocation && workLocation.value,
			"status": (status && status.value) || "approved",
			"note": comment,
		};

		if (modalTimesheet) {
			timesheetData["original-time-in"] = modalTimesheet["original-time-in"] || modalTimesheet["time-in"];
			timesheetData["original-time-out"] = modalTimesheet["original-time-out"] || modalTimesheet["time-out"];
			timesheetData["original-date"] = modalTimesheet["original-date"] || modalTimesheet["date"];
			timesheetData["original-break"] = modalTimesheet["original-break"] || modalTimesheet["break"];
		}

		myAgreements && mySaveTimesheet(timesheetData);
		employeeList && timesheetSave(timesheetData);
		// console.log('saveTimesheetData',timesheetData)
	};

	const deleteTimesheetData = () => {
		const timesheetData = {
			...modalTimesheet,
			status: "deleted",
		};

		employeeList && timesheetSave(timesheetData);
		// console.log('saveTimesheetData',timesheetData)
	};

	const calculateHours = (timeIn, timeOut, breakDuration) => {
		if (timeIn && timeOut) {
			const breakDurationInHours = (breakDuration || 0) / 60;

			console.log("timeIn", timeIn, timeOut);

			let hourIn = timeToHours(timeIn.toISOString().substring(11, 16));
			let hourOut = timeToHours(timeOut.toISOString().substring(11, 16));

			if (hourOut < hourIn) {
				// if after midnight add 24hrs so we can keep counting properly
				hourOut += 24;
			}

			setHoursWorked((hourOut - hourIn - breakDurationInHours).toFixed(2));
		}
	};

	const handleBreakChange = (value) => {
		numSchema.isValid({ minutes: value.replace("", 0) }).then(function (valid) {
			if (valid) {
				calculateHours(timeIn, timeOut, value);
				setBreakDuration(value);
				setErrorText("");
			} else {
				setErrorText("Break duration is invalid!");
			}
		});
	};

	const handleWorkedHoursChange = (value) => {
		numSchema.isValid({ hours: value.replace("", 0) }).then(function (valid) {
			if (valid) {
				setHoursWorked(value);
				setErrorText("");
			} else {
				setErrorText("Hours worked cannot be under 0 or over 24!");
			}
		});
	};

	console.log("didyouupdate", date, timeIn, timeOut);

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div
				className="modal-dialog"
				style={{ marginTop: "5%" }}
			>
				<div className="modal-content">
					<div className="block block-themed block-transparent remove-margin-b">
						<div className="block-header bg-primary-dark">
							<ul className="block-options">
								<li>
									<button
										id="close-modal"
										type="button"
										onClick={() => {
											timesheetSetOpenModal(false, null);
										}}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">{modalTimesheet ? "Edit" : "Add"} Time Entry</h3>
						</div>
						<div className="block-content">
							<div className="form-group">
								{employeeOptions && (
									<div
										className="col-sm-6"
										style={{ paddingLeft: 0 }}
									>
										<label htmlFor="material-text">Employee</label>
										<Select
											value={employee}
											options={employeeOptions}
											onChange={setEmployee}
											isDisabled={location == "employeeTimesheets" || modalTimesheet}
										/>
										<div className="clearfix" />
									</div>
								)}
								{/* {
                  agreementOptions && 
                  <div className="col-sm-6" style={{paddingLeft: 0}}>
                    <label htmlFor="material-text">Company</label>
                    <Select
                      value={employee}
                      options={agreementOptions}
                      onChange={setEmployee}
                    /> 
                    <div className="clearfix" />
                  </div>
                } */}
								{workLocationOptions?.length > 0 && (
									<div
										className="col-sm-6"
										style={{ paddingLeft: 0, paddingRight: 0 }}
									>
										<label htmlFor="material-text">Work Location</label>
										<Select
											value={workLocation}
											options={workLocationOptions}
											isClearable
											onChange={setWorkLocation}
										/>
										<div className="clearfix" />
									</div>
								)}
								<div className="clearfix" />
							</div>
							<div className="clearfix" />
							<div className="form-group">
								<div
									id="date-in"
									className="col-sm-4"
								>
									<label>Date</label>
									<DatePicker
										selected={date}
										onChange={(date) => setDate(date)}
										minDate={subYears(new Date(), 100)}
										maxDate={
											(employee &&
												employee.terminationDate &&
												new Date(employee.terminationDate)) ||
											today
										}
										dateFormat="dd/MM/yyyy"
										customInput={<DateInputFormat />}
									/>
									{/*<input id="date" type="text" className="form-control remove_error" name="date" />*/}
									<div className="clearfix" />
								</div>
								<div
									id="time-in"
									className="col-sm-4"
								>
									<label htmlFor=" ">Time In</label>
									{console.log("datepickerTimeIn", timeIn)}
									<DatePicker
										selected={timeIn}
										onChange={(timeInDate) => {
											const dateToUse = new Date(
												format(
													set(date, {
														hours: format(timeInDate, "HH"),
														minutes: format(timeInDate, "mm"),
														seconds: 0,
														milliseconds: 0,
													}),
													"yyyy-MM-dd'T'HH:mm:ss",
												),
											);
											setTimeIn(dateToUse);
											calculateHours(dateToUse, timeOut, breakDuration);
										}}
										showTimeSelect
										showTimeSelectOnly
										timeIntervals={15}
										timeCaption="Time"
										dateFormat="h:mm aa"
										customInput={<TimeInputFormat />}
									/>
									<div className="clearfix" />
								</div>
								<div
									id="time-out"
									className="col-sm-4"
								>
									<label htmlFor=" ">Time Out</label>
									<DatePicker
										selected={timeOut}
										onChange={(timeOutDate) => {
											const dateToUse = new Date(
												format(
													set(date, {
														hours: format(timeOutDate, "HH"),
														minutes: format(timeOutDate, "mm"),
														seconds: 0,
														milliseconds: 0,
													}),
													"yyyy-MM-dd'T'HH:mm:ss",
												),
											);
											setTimeOut(dateToUse);
											calculateHours(timeIn, dateToUse, breakDuration);
										}}
										showTimeSelect
										showTimeSelectOnly
										timeIntervals={15}
										timeCaption="Time"
										dateFormat="h:mm aa"
										customInput={<TimeInputFormat />}
									/>
									<div className="clearfix" />
								</div>
								<div className="clearfix" />
							</div>
							<div className="clearfix" />
							<div className="form-group">
								<div className="col-sm-4">
									<label>Break Duration (minutes)</label>
									<input
										id="break-time"
										className="form-control form-input"
										type="number"
										name="break-duration"
										onChange={(e) => {
											if (isNumber(e.target.value)) {
												handleBreakChange(e.target.value);
											} else {
												calculateHours(timeIn, timeOut, 0);
												setBreakDuration(0);
											}
										}}
										value={breakDuration}
									/>
									<div className="clearfix" />
								</div>
								<div className="col-sm-4">
									<label>Hours Worked</label>

									<input
										id="hours-worked"
										className="form-control form-input"
										type="text"
										name="break-duration"
										onChange={(e) => {
											if (isNumber(e.target.value) || e.target.value == "") {
												handleWorkedHoursChange(e.target.value);
											}
										}}
										disabled={!canEditHours}
										value={hours}
									/>
									<div
										id="toggle-hours-worked"
										onClick={() => {
											setCanEditHours(!canEditHours);
											if (canEditHours) {
												// reset calculation
												calculateHours(timeIn, timeOut, breakDuration);
											} else {
												// add notification here
												NotificationManager.warning(
													`Editing hours and not time-in/out may have an adverse impact on your payroll.`,
													"Warning",
												);
											}
										}}
										style={{
											position: "absolute",
											right: 25,
											bottom: 5,
											padding: "0",
											zIndex: 2,
											lineHeight: "30px",
											color: "black",
											background: "none",
											border: "none",
											cursor: "pointer",
										}}
										title="The hours are automatically computed. Click here to manually edit. PS. manual editing may impact computations when time-in/out are required such as for night-shift payment"
									>
										{canEditHours ? (
											<LinkIcon style={{ height: "1.25em", verticalAlign: "middle" }} />
										) : (
											<MinusCircleIcon style={{ height: "1.25em", verticalAlign: "middle" }} />
										)}
									</div>
									<div className="clearfix" />
								</div>
								{timesheetStatusOptions && (
									<div
										className="col-sm-4"
										style={{ paddingLeft: 0 }}
									>
										<label htmlFor="material-text">Status</label>
										<Select
											value={status}
											options={timesheetStatusOptions}
											onChange={setStatus}
										/>
										<div className="clearfix"></div>
										<p
											style={{ textAlign: "left", color: "#ff5555" }}
											id="num-error"
										>
											{errorText}
										</p>
									</div>
								)}
								<div className="clearfix" />
								<div>
									<label htmlFor="material-text">Comment</label>

									<textarea
										id="comment"
										className="form-control form-input"
										type="text"
										name="Comment"
										style={{ minHeight: 100, maxHeight: 400, resize: "vertical" }}
										onChange={(e) => {
											setComment(e.target.value);
											console.debug("e.target.value: ", e.target.value);
											console.debug("comment: ", comment);
										}}
										value={comment}
									/>
								</div>
								<div className="clearfix" />
							</div>
							<div className="clearfix" />

							{/*<div className="form-group">
                <div className="col-sm-12" style={{paddingRight: 0, paddingLeft: 0}}>
                  <div className="form-material">
                    <label htmlFor=" ">Notes</label>
                    <textarea id="timesheets-note" name="note" className="form-control disabled edit" rows="1"></textarea>
                    <div className="clearfix" />
                  </div>
                  <div className="clearfix" />
                </div>
                <div className="clearfix" />
              </div>*/}
							<div className="clearfix" />
							<div className="block buttons">
								{modalTimesheet &&
									!modalTimesheet.isPaid &&
									employeeList &&
									modalTimesheet.status !== "deleted" && (
										<button
											className="btn btn-danger pull-left"
											onClick={() => deleteTimesheetData()}
											style={{ marginRight: 0 }}
										>
											<i
												className="fas fa-lock"
												style={{ marginRight: "5px" }}
											/>
											Delete Timesheet
										</button>
									)}
								{modalTimesheet && modalTimesheet.isPaid && (
									<button
										className="btn btn-default pull-right"
										style={{ marginRight: 0 }}
									>
										<i
											className="fas fa-lock"
											style={{ marginRight: "5px" }}
										/>
										Timesheet Paid
									</button>
								)}
								{modalTimesheet && modalTimesheet.deputy && (
									<button
										className="btn btn-default pull-right"
										style={{ marginRight: 0 }}
									>
										<i
											className="fas fa-lock"
											style={{ marginRight: "5px" }}
										/>
										Timesheet Created via Deputy
									</button>
								)}
								{!(modalTimesheet && (modalTimesheet.isPaid || modalTimesheet.deputy)) &&
									!hasRequired && (
										<button
											className="btn btn-default pull-right"
											style={{ marginRight: 0 }}
										>
											Time Entry Incomplete
										</button>
									)}
								{!(modalTimesheet && (modalTimesheet.isPaid || modalTimesheet.deputy)) && !isValid && (
									<button
										className="btn btn-default pull-right"
										style={{ marginRight: 0 }}
									>
										Time Entry Invalid
									</button>
								)}
								{!(modalTimesheet && (modalTimesheet.isPaid || modalTimesheet.deputy)) &&
									hasRequired &&
									!modalSaving &&
									isValid && (
										<button
											className="btn btn-success pull-right"
											onClick={() => saveTimesheetData()}
											style={{ marginRight: 0 }}
										>
											Submit
										</button>
									)}

								<div className="clearfix" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	let workLocations =
		state.workLocation && state.workLocation.workLocationSettings && state.workLocation.workLocationSettings.types;

	const workLocationOptions =
		workLocations &&
		workLocations.map((workLocation) => ({
			value: workLocation.id,
			label: workLocation.name,
			applyIfBalanceAvailable: workLocation.applyIfBalanceAvailable,
			managerCanApprove: workLocation.managerCanApprove,
			employeeCanApply: workLocation.employeeCanApply,
		}));

	const timesheetStatusOptions = [
		{
			value: "Approved",
			label: "Approved",
		},
		{
			value: "Pending",
			label: "Pending",
		},
		{
			value: "deleted",
			label: "Deleted",
		},
	];

	const employeeDetails = {
		value: state.employee?.employeeDetails?.id,
		employmentType: state.employee?.salaries?.slice(-1)[0]?.employmentTypeName,
		label: `${state.employee?.employeeDetails?.employeeDetails?.givenName} ${state.employee?.employeeDetails?.employeeDetails?.familyName}`,
	};

	return {
		workLocationOptions,
		timesheetStatusOptions,
		...state.timesheets,
		...state.employees,
		...state.my,
		employeeDetails,
	};
};

const mapDispatchToProps = (dispatch) => ({
	timesheetSetOpenModal: (status, timesheet) => dispatch(ACTIONS.timesheetSetOpenModal(status, timesheet)),
	timesheetSave: (timesheet) => dispatch(ACTIONS.timesheetSave(timesheet)),
	mySaveTimesheet: (timesheet) => dispatch(MYACTIONS.mySaveTimesheet(timesheet)),
	getWorkLocationSettings: () => dispatch(WORKLOCATIONACTIONS.getWorkLocationSettings()),
	// timesheetUpdateSaveStatus: (status) => dispatch(ACTIONS.timesheetUpdateSaveStatus(status))
});

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetModal);
